<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import DxButton from 'devextreme-vue/button';
import DxToolbar, { DxItem } from 'devextreme-vue/toolbar';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver-es';
import { exportDataGrid } from 'devextreme/excel_exporter';
import Loader from "../components/loader";
import CustomStore from 'devextreme/data/custom_store';
import api from "@/axios";
import Swal from "sweetalert2";

import {
  DxDataGrid,
  DxColumn,
  DxColumnChooser,
  DxColumnFixing,
  DxSelection,
  DxExport,
  DxStateStoring,
  DxGroupPanel, DxGrouping,
  DxPager, DxFilterRow, DxRemoteOperations
} from 'devextreme-vue/data-grid';
import moment from "moment";
import {getBaseUrl} from "@/helpers/baseUrl";


export default {

  components: {
    Layout, PageHeader, DxButton,
    DxDataGrid, DxColumn, DxColumnChooser, DxColumnFixing, DxSelection, DxExport,
    DxStateStoring, DxGroupPanel, DxGrouping, DxToolbar, DxItem, DxPager, DxFilterRow, DxRemoteOperations,
    Loader
  },
  data() {

    return {
      title: "Grid Notas Fiscais",
      items: [
        {
          text: "Fretes",
          href: "/"
        },
        {
          text: "Grid Notas Fiscais",
          active: true
        }
      ],
      selectedItems: 0,
      dataList: null,
      updating: false,
      dtIniFiltro: null,
      dtFimFiltro: null,
      submittedPeriodo: false,
      showModalPeriodo: false,

      showModalErros: false,
      dtListErrors: [],

    };
  },



  computed: {
    dataGrid: function() {
      return this.$refs.dataGridRefKey.instance
    }
  },

  mounted() {
    console.log('mounted mov-list_0')
    this.atualizaDataList()
  },

  methods: {
    formatDateTime(value) {
      const format = "DD/MM/YYYY HH:mm:ss";
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      return dateTime;
    },

    atualizarItensSelecionados(e) {
      this.selectedItems = e.selectedRowsData.length
    },

    confirmarPeriodo(){
      console.log('confirmarPeriodo')

      localStorage.setItem('filtros', JSON.stringify({
        'movdi': moment(this.dtIniFiltro).format('YYYY-MM-DD'),
        'movdf': moment(this.dtFimFiltro).format('YYYY-MM-DD'),
      }))


      this.showModalPeriodo = false
      this.atualizaDataList()
    },



    carregouGrid(e){
      console.log('carregouGrid')

      const dtIniFormated = moment(this.dtIniFiltro).format('DD/MM/YYYY')
      const dtFimFormated = moment(this.dtFimFiltro).format('DD/MM/YYYY')

      this.title = `(${e.component.totalCount()}) Grid Notas Fiscais ${dtIniFormated} - ${dtFimFormated}`



    },

    atualizaDataList(){
      console.log('atualizaDataList_mov_elasticsearch')

      const filtros = JSON.parse(localStorage.getItem("filtros"))
      console.log('filtros')
      console.log(filtros)
      if (!filtros) {
        console.log('cookie dataMov não existe, criando')
        console.log('sem filtro')
        let perIniPadrao = moment(new Date())
            .add(-15, 'days')
            .format('YYYY-MM-DD')
        let perFimPadrao = moment(new Date())
            .format('YYYY-MM-DD')
        this.dtIniFiltro = perIniPadrao
        this.dtFimFiltro = perFimPadrao
        localStorage.setItem('filtros', JSON.stringify({
          'movdi': perIniPadrao,
          'movdf': perFimPadrao,
        }))
      } else {
        this.dtIniFiltro = filtros['movdi']
        this.dtFimFiltro = filtros['movdf']
      }

      if (!this.dtIniFiltro && !this.dtFimFiltro){
        console.log('sem filtro')
        let perIniPadrao = moment(new Date())
            .add(-15, 'days')
            .format('YYYY-MM-DD')
        let perFimPadrao = moment(new Date())
            .format('YYYY-MM-DD')
        this.dtIniFiltro = perIniPadrao
        this.dtFimFiltro = perFimPadrao
      }
      const di = this.dtIniFiltro
      const df = this.dtFimFiltro

      this.dataList = new CustomStore({
        key: "chave",
        load: (loadOptions) => {

          let queryArray = []
          if (loadOptions['filter']) {
            if (loadOptions['filter'][1] === 'and' || loadOptions['filter'][1] === 'or') {
              loadOptions['filter'].forEach((value) => {
                if (typeof (value) === "object") {
                  queryArray.push({
                    cmp: value[0],
                    opr: value[1],
                    val: value[2],
                  })
                }
              })
            } else {
              queryArray.push({
                cmp: loadOptions['filter'][0],
                opr: loadOptions['filter'][1],
                val: loadOptions['filter'][2],
              })
            }
          }
          const paramsReq = {
            'skip': loadOptions['skip'] || 0,
            'take': loadOptions['take'] > 0 ? loadOptions['take'] : 20,
            'filter': queryArray,
            'sort': loadOptions['sort'],
            'di': di,
            'df': df
          }

          console.log('paramsReq')
          console.log(JSON.stringify(paramsReq))

          return api.get(`${getBaseUrl()}api/elasticmovsrel`, {
            params: paramsReq
          }).then(response => {
            console.log('response.data_0')
            console.log(response)

            if (!Array.isArray(response.data) || response.data.length < 2) {
              console.warn('Resposta inesperada da API:', response.data)
              return { data: [], totalCount: 0 }
            }

            if (response.data[0]) {
              response.data[0].forEach(item => {
                const cteValor = parseFloat(item.zz_cte_valor || 0)
                const cteValorCarga = parseFloat(item.zz_cte_valor_carga || 0)
                const valorNota = parseFloat(item.valor || 0)

                if (cteValorCarga > 0) {
                  item.valfreteprop = (cteValor / cteValorCarga) * valorNota
                } else {
                  item.valfreteprop = 0
                }
              })
            }

            return {
              data: response.data[0],
              totalCount: response.data[1],
            }
          }).catch(err => {
            console.error('Erro ao buscar notas fiscais:', err)
            return { data: [], totalCount: 0 }
          })
        },
      })

      console.log('dataList')
      console.log(this.dataList.data)
    },

    onRowDblClick(row) {
      console.log('onRowDblClick')
      let idData = row.key
      console.log(idData)
      const routeData = this.$router.resolve(`/movimento/editar/${idData}`)
      window.open(routeData.href, '_blank')
    },

    onCellPrepared(e) {
      if (e.rowType === "data") {
        if (e.column.name === "status_nome") {
          const valStatus = e.data.w_trk_ult_status_nome
          let corStatus = 'rgba(78,59,0,0.5)'
          switch (valStatus) {
            case 'Em Trânsito':
              corStatus = 'rgba(146,111,0,0.5)'
              break
            case 'Entrega Finalizada':
              corStatus = 'rgba(33,78,0,0.5)'
              break
            case 'Ocorrência':
              corStatus = 'rgba(146,20,0,0.5)'
              break
          }
          e.cellElement.style.cssText = `color: white; background-color: ${corStatus}`;

        }
      }
    },


    onExporting(e){
      console.log('onExporting')

      const totalCount = e.component.totalCount();
      if (totalCount > 2000) {
        Swal.fire({
          icon: 'warning',
          title: 'Atenção',
          text: 'O número de registros excede o limite de 2000 para exportação. Apenas os primeiros 2000 serão baixados.',
          confirmButtonText: 'Continuar'
        });
      }

      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet('plan1');
      exportDataGrid({
        component: e.component,
        worksheet,
        exportAll: true,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), this.title + '.xlsx');
        });
      });
      e.cancel = true;
    },

    refeFormTable(){
      console.log('refeFormTable')
      this.dataGrid.state(null);

    },

    formatDecimal(value) {
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2});
      }
      return 0.00;
    },
  },

};

</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" @click="showModalPeriodo = true"/>

    <div>

      <DxToolbar>

        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="refresh"
              hint="Redefinir formatação de tabela para padrão"
              :on-click="refeFormTable"/>
        </DxItem>
      </DxToolbar>
    </div>

    <Loader v-if="updating" style="min-height: 300px;">
    </Loader>

    <div class="mt-2">
      <p><strong>Itens Selecionados: {{ selectedItems }}</strong></p>
    </div>

    <div class="mt-2" v-if="!updating">

      <DxDataGrid
          ref="dataGridRefKey"
          :data-source="dataList"
          :show-borders="true"
          :focused-row-enabled="true"
          :column-auto-width="true"
          :show-row-lines="true"
          :allow-column-reordering="true"
          :allow-column-resizing="true"
          :row-alternation-enabled="true"
          @cell-prepared="onCellPrepared"
          @row-dbl-click="onRowDblClick"
          @content-ready="carregouGrid"
          @exporting="onExporting"
          @selection-changed="atualizarItensSelecionados"
      >

        <DxRemoteOperations
            :filtering="true"
            :paging="true"
            :sorting="true"
            :summary="true"
            :grouping="false"
            :group-paging="false"
        />


        <DxColumnChooser :enabled="true"/>
        <DxColumnFixing :enabled="true"/>
        <DxFilterRow :visible="true" />


        <DxSelection mode="multiple"
selectAllMode="allPages" /> <!--:allow-select-all="false"-->

        <DxExport
            :enabled="true"
            :allow-export-selected-data="true"/>
        <DxStateStoring
            :enabled="true"
            type="sessionStorage"
            storage-key="strMovList"/>

        <DxGroupPanel :visible="true"/>
        <DxGrouping />

        <DxColumn
            :width="330"
            caption="Movimentos"
            alignment="center"
            :allowHeaderFiltering="false">

          <DxColumn
              data-field="numero"
              name="numero_id"
              sort-order="desc"
              caption="ID"
              data-type="number"
              alignment="right"
              :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
              :allowHeaderFiltering="true"/>

          <DxColumn
              data-field="w_trk_ult_status_nome"
              name="status_nome"
              caption="Status"
              alignment="center"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allowHeaderFiltering="true" />

          <DxColumn
              data-field="emissao"
              caption="Emissão"
              alignment="right"
              data-type="date"
              format="dd/MM/yyyy"
              :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
              :allowHeaderFiltering="true"/>

          <DxColumn
              data-field="numero"
              name="numero_nf"
              caption="NF"
              alignment="right"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allowHeaderFiltering="true"/>

          <DxColumn
              data-field="valor"
              caption="Valor"
              alignment="right"
              data-type="number"
              :format="formatDecimal"
              :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
              :allowHeaderFiltering="true"/>

          <DxColumn
              data-field="peso_bruto"
              caption="Peso"
              alignment="right"
              :format="formatDecimal"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith','=', '<>', '<', '>', '<=', '>=']"
              :allowHeaderFiltering="true"/>

          <DxColumn
              data-field="mov_valorfrete"
              caption="Frete Loja"
              alignment="right"
              :format="formatDecimal"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith','=', '<>', '<', '>', '<=', '>=']"
              :allowHeaderFiltering="true" />

          <DxColumn
              data-field="w_trk_data_entrega"
              name="dt_entrega"
              caption="Dt Entrega"
              alignment="right"
              data-type="date"
              format="dd/MM/yyyy"
              :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
              :allowHeaderFiltering="true"/>

          <DxColumn
              data-field="@timestamp"
              caption="Dt Recebimento NF"
              alignment="right"
              data-type="date"
              format="dd/MM/yyyy"
              :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
              :allowHeaderFiltering="true"/>

          <DxColumn
              data-field="natureza"
              caption="Natureza"
              alignment="left"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allowHeaderFiltering="true" />
        </DxColumn>

        <DxColumn
            :width="330"
            caption="Rastreamento"
            alignment="center"
            :allowHeaderFiltering="false">

            <DxColumn
              :width="80"
              data-field="w_trk_resposta"
              caption="Consulta Rastreio"
              alignment="center"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allowHeaderFiltering="true"
              
            />

            <DxColumn
              data-field="w_trk_ult_data"
              caption="Atualizada em"
              alignment="right"
              data-type="date"
              format="dd/MM/yyyy"
              :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
              :allowHeaderFiltering="false"/>

            <DxColumn
              data-field="w_trk_ult_status"
              caption="Descrição"
              alignment="center"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allowHeaderFiltering="true" />

            <DxColumn
              data-field="w_trk_data"
              caption="Processada em"
              alignment="right"
              data-type="datetime"
              format="dd/MM/yyyy HH:mm:ss"
              :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
              :allowHeaderFiltering="false"/>

            <DxColumn
              data-field="status_processamento"
              caption="Status Processamento"
              alignment="center"
              data-type="string"
              :filter-operations="['contains', 'notcontains', '=', '<>']"
              :allowHeaderFiltering="true"/>

        </DxColumn>

        <DxColumn
            :width="330"
            caption="CTE"
            alignment="center"
            :allowHeaderFiltering="false">

          <DxColumn
              :width="80"
              data-field="zz_cte_numero"
              caption="Número"
              alignment="right"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allowHeaderFiltering="true"/>

          <DxColumn
              :width="100"
              data-field="zz_cte_emissao"
              caption="Dt Emissão"
              alignment="right"
              data-type="date"
              format="dd/MM/yyyy"
              :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
              :allowHeaderFiltering="false"/>

          <DxColumn
              :width="100"
              data-field="zz_cte_previsao_entrega"
              name="cte_previsao"
              caption="Previsão"
              alignment="right"
              data-type="date"
              format="dd/MM/yyyy"
              :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
              :allowHeaderFiltering="false"/>

          <DxColumn
              :width="110"
              data-field="previsao_cotacao"
              name="cotacao_previsao"
              caption="Prev. Tab."
              alignment="right"
              data-type="string"
              :filter-operations="['contains', 'notcontains', '=', '<>']"
              :allowHeaderFiltering="false"/>

          <DxColumn
              data-field="zz_cte_peso_maior"
              caption="Peso"
              :format="formatDecimal"
              alignment="right"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith','=', '<>', '<', '>', '<=', '>=']"
              :allowHeaderFiltering="false" />

          <DxColumn
              data-field="zz_cte_valor"
              caption="Valor Frete"
              alignment="right"
              :format="formatDecimal"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith','=', '<>', '<', '>', '<=', '>=']"
              :allowHeaderFiltering="false" />

          <DxColumn
              data-field="valfreteprop"
              caption="Valor proporcional"
              alignment="right"
              data-type="number"
              :format="formatDecimal"
              :filter-operations="[]"
              :allowHeaderFiltering="false" />
        </DxColumn>

        <DxColumn
            :width="330"
            caption="Destinatário"
            alignment="center"
            :allow-sorting="false"
            :allowHeaderFiltering="false">

          <DxColumn
              data-field="dest_nome"
              caption="Nome"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allow-sorting="false"
              :allowHeaderFiltering="false"/>

          <DxColumn
              data-field="dest_cnpj"
              caption="CNPJ"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allow-sorting="false"
              :allowHeaderFiltering="false"/>

          <DxColumn
              data-field="dest_cidade"
              caption="Cidade"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allow-sorting="false"
              :allowHeaderFiltering="false"/>

          <DxColumn
              data-field="dest_estado"
              caption="Estado"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allow-sorting="false"
              :allowHeaderFiltering="false"/>

        </DxColumn>


        <DxColumn
            :width="330"
            caption="Remetente"
            alignment="center"
            :allow-sorting="false"
            :allowHeaderFiltering="false">

          <DxColumn
              data-field="zz_cte_remet_nome"
              caption="Nome"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allow-sorting="false"
              :allowHeaderFiltering="false"/>

          <DxColumn
              data-field="zz_cte_remet_cnpj"
              caption="CNPJ"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allow-sorting="false"
              :allowHeaderFiltering="false"/>

          <DxColumn
              data-field="zz_cte_remet_cidade"
              caption="Cidade"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allow-sorting="false"
              :allowHeaderFiltering="false"/>

          <DxColumn
              data-field="zz_cte_remet_estado"
              caption="Estado"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allow-sorting="false"
              :allowHeaderFiltering="false"/>

        </DxColumn>

        <DxColumn
            :width="330"
            caption="Transportador"
            alignment="center"
            :allow-sorting="false"
            :allowHeaderFiltering="false">

          <DxColumn
              data-field="zz_cte_emit_nome"
              caption="Nome"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allow-sorting="false"
              :allowHeaderFiltering="false"/>

          <DxColumn
              data-field="zz_cte_emit_cnpj"
              caption="CNPJ"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allow-sorting="false"
              :allowHeaderFiltering="false"/>

          <DxColumn
              data-field="zz_cte_emit_cidade"
              caption="Cidade"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allow-sorting="false"
              :allowHeaderFiltering="false"/>

          <DxColumn
              data-field="zz_cte_emit_estado"
              caption="Estado"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allow-sorting="false"
              :allowHeaderFiltering="false"/>

        </DxColumn>



        <DxPager
            :visible="true"
            :show-page-size-selector="true"
            :allowed-page-sizes="[10, 30, 50, 100]"
            :show-navigation-buttons="true"
            :show-info="true"/>


      </DxDataGrid>


    </div>


    <b-modal title="Período de Exibição" v-model="showModalPeriodo" centered hide-footer>
      <div class="col-md-12">
        <div class="mb-3">
          <label for="tipooperacao">Selecionar Data Inicial e Final</label>

        </div>
      </div>
      <div class="row">

        <div class="col-md-6">
          <div class="mb-3">
            <label for="dtIniFiltro">Data Início</label>
            <input
                id="dtIniFiltro"
                v-model="dtIniFiltro"
                type="date"
                class="form-control"
                placeholder="Data Início"
                :class="{'is-invalid': submittedPeriodo && !dtIniFiltro,}"/>
            <div v-if="submittedPeriodo && !dtIniFiltro"
                 class="invalid-feedback">
              <span >Campo data início obrigatório, favor preencher.</span>
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div class="mb-3">
            <label for="dtFimFiltro">Data Final</label>
            <input
                id="dtFimFiltro"
                v-model="dtFimFiltro"
                type="date"
                class="form-control"
                placeholder="Data Final"
                :class="{'is-invalid': submittedPeriodo && !dtFimFiltro,}"/>
            <div v-if="submittedPeriodo && !dtFimFiltro"
                 class="invalid-feedback">
              <span >Campo data final obrigatória, favor preencher.</span>
            </div>
          </div>
        </div>

      </div>
      <div class="text-end mt-5">
        <b-button variant="light" @click="showModalPeriodo = false">
          <i class="bx bx-block font-size-16 align-middle me-2"></i>
          Cancelar
        </b-button>
        <b-button type="submit" variant="success" class="ms-1" @click="confirmarPeriodo">
          <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
          Confirmar
        </b-button>
      </div>
    </b-modal>

    <b-modal
      v-model="showModalErros"
      id="showModalErros"
      size="lg"
      title="Erros gerados na ação"
      title-class="font-18"
      hide-footer>
      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <div class="table-responsive">
                <table class="table mb-0">
                  <thead class="table-light">
                    <tr>
                      <th>Erro</th>
                      <th>Valor</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="data in dtListErrors" :key="data.id">
                      <td>{{data.erro}}</td>
                      <td>{{data.valor}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>       
      </div>
    </b-modal>
  </Layout>
</template>



<style>
#btnAjuda .dx-icon {
  color: #fff !important;
}
</style>

